import { createContext, ReactNode, useCallback, useMemo, useReducer } from 'react';
import { LayoutContextValue, LayoutType, setLayoutProp } from '@contexts/layout/layout.type';

export const LayoutContext = createContext<LayoutContextValue>({
  layoutType: undefined,
  setLayout: () => {},
});

interface LayoutState {
  layoutType: LayoutType;
  topElementNode: ReactNode;
  bottomElementNode: ReactNode;
}

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [state, dispatch] = useReducer(
    (_prev: LayoutState, action: setLayoutProp): LayoutState => ({
      layoutType: action.type,
      topElementNode: action.topElement,
      bottomElementNode: action.bottomElement,
    }),
    { layoutType: undefined, topElementNode: undefined, bottomElementNode: undefined }
  );

  const setLayout = useCallback((props: setLayoutProp) => {
    dispatch(props);
  }, []);

  const contextValue = useMemo(() => ({ layoutType: state.layoutType, setLayout }), [state.layoutType, setLayout]);

  return (
    <LayoutContext.Provider value={contextValue}>
      {!!state.topElementNode && state.topElementNode}
      {children}
      {!!state.bottomElementNode && state.bottomElementNode}
    </LayoutContext.Provider>
  );
};
